import React, { useEffect, useState } from "react";
import CustomButton from "../../../ui/custom-button";
import { PulseLoader } from "react-spinners";
import CustomInput from "../../../ui/custom-input";
import Customform from "../../../ui/custom-form";
import { IoCloseOutline } from "react-icons/io5";
import {
  AddUsecaseApi,
  UpdateUsecaseApi,
  UseCaseeventListApi,
} from "../../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";

function AddUsecase() {
  const dispatch = useDispatch();
  const [inputData, setInputData] = useState({
    usecase_name: "",
    usecase_description: "",
    operation: "",
    server_url: "",
  });
  const [loading, setLoading] = useState(false);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  const fetchDetail = async () => {
    try {
      const res = await UseCaseeventListApi(data, user_id, organization_id);
      const fetched = res?.data?.data;
      console.log("fetched", fetched);
      if (fetched) {
        setInputData({
          usecase_name: fetched.usecase_name,
          usecase_description: fetched.usecase_description,
          operation: fetched.operation,
          server_url: fetched.server_url,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (data) {
        const payload = {
          usecase_name: inputData.usecase_name,
          usecase_description: inputData.usecase_description,
          operation: inputData.operation,
          server_url: inputData.server_url,
          user_id,
          organization_id,
        };

        let editdata = await UpdateUsecaseApi(data, payload);
        if (editdata) {
          handleClose();
        }
      } else {
        const payload = {
          usecase_name: inputData.usecase_name,
          usecase_description: inputData.usecase_description,
          operation: inputData.operation,
          server_url: inputData.server_url,
          user_id,
          organization_id,
        };

        let data = await AddUsecaseApi(payload);
        if (data) {
          handleClose();
        }
      }
    } catch (err) {
      console.error("Error submitting usecase:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  useEffect(() => {
    if (data) {
      fetchDetail();
    }
  }, [data]);

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Add" : "Edit"} Usecase</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12 mb-3">
            <label className="form-label">Usecase Name</label>
            <CustomInput
              name="usecase_name"
              placeholder="Enter Usecase Name"
              value={inputData.usecase_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Usecase Direction</label>
            <CustomInput
              name="usecase_description"
              placeholder="Enter Direction"
              value={inputData.usecase_description}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Operation</label>
            <CustomInput
              name="operation"
              placeholder="Enter Operation"
              value={inputData.operation}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Server URL</label>
            <CustomInput
              name="server_url"
              placeholder="Enter Server URL"
              value={inputData.server_url}
              onChange={handleChange}
            />
          </div>

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            <CustomButton type="submit" className="btnSubmit px-4 py-2">
              {loading ? (
                <PulseLoader color="#fff" size={8} />
              ) : data ? (
                "Update"
              ) : (
                "Submit"
              )}
            </CustomButton>
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddUsecase;
